import LazyLoad from "vanilla-lazyload";
import templateToolbox from "./template-toolbox";

const singleToolbox = {
  init() {
    this.events();
    templateToolbox.events();
  },

  events() {
    singleToolbox.playHeroVideo();
  },

  playHeroVideo() {
    // play video in hero
    const playBtn = document.getElementById("playBtn");
    const video = document.getElementById("heroVideo");

    if (playBtn) {
      playBtn.addEventListener("click", () => {
        playBtn.parentNode.classList.toggle("loading");

        LazyLoad.load(video, {
          callback_loaded: () => {
            playBtn.parentNode.classList.toggle("loaded");

            setTimeout(() => {
              video.play();
            }, 200);
          },
        });
      });
    }
  },


};

export default singleToolbox;
